import Search from '../components/Search';
export default{
  name: 'intro',
  components: {
    'search': Search
  }
}



// WEBPACK FOOTER //
// ./src/mv/intro.js